import React, { createContext, useContext, useState, useCallback } from 'react';

interface MobileAIChatContextType {
  isOpen: boolean;
  openAIChat: () => void;
  closeAIChat: () => void;
  toggleAIChat: () => void;
}

const MobileAIChatContext = createContext<MobileAIChatContextType | undefined>(undefined);

export const MobileAIChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openAIChat = useCallback(() => setIsOpen(true), []);
  const closeAIChat = useCallback(() => setIsOpen(false), []);
  const toggleAIChat = useCallback(() => setIsOpen(prev => !prev), []);

  return (
    <MobileAIChatContext.Provider value={{ isOpen, openAIChat, closeAIChat, toggleAIChat }}>
      {children}
    </MobileAIChatContext.Provider>
  );
};

export const useMobileAIChat = (): MobileAIChatContextType => {
  const context = useContext(MobileAIChatContext);
  if (!context) {
    throw new Error('useMobileAIChat must be used within a MobileAIChatProvider');
  }
  return context;
};
